var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7458 13.0805L13.2158 11.6105C13.4138 11.415 13.6643 11.2811 13.9369 11.2252C14.2095 11.1693 14.4925 11.1937 14.7514 11.2955L16.543 12.0108C16.8047 12.1171 17.0291 12.2984 17.188 12.532C17.3468 12.7655 17.4329 13.0409 17.4355 13.3233V16.6046C17.434 16.7967 17.3936 16.9866 17.3168 17.1627C17.2399 17.3388 17.1283 17.4975 16.9885 17.6294C16.8487 17.7612 16.6837 17.8634 16.5033 17.9297C16.323 17.9961 16.1311 18.0253 15.9392 18.0155C3.38518 17.2346 0.85206 6.60334 0.372997 2.53459C0.350759 2.33479 0.371078 2.13254 0.432617 1.94115C0.494155 1.74976 0.59552 1.57357 0.730041 1.42418C0.864563 1.27478 1.02919 1.15555 1.2131 1.07435C1.39701 0.993142 1.59603 0.951796 1.79706 0.95303H4.96675C5.2496 0.953867 5.52573 1.03931 5.75963 1.19836C5.99352 1.35741 6.17449 1.58279 6.27925 1.84553L6.99456 3.63709C7.09973 3.89504 7.12656 4.17826 7.0717 4.45138C7.01685 4.72449 6.88274 4.97538 6.68612 5.17272L5.21612 6.64272C5.21612 6.64272 6.06268 12.3718 11.7458 13.0805Z",
    fill: "#0A0A0A",
    fillOpacity: 0.76
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.d7cc7108.svg";
export { ForwardRef as ReactComponent };